import React, { useCallback, useRef, useState } from 'react';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { Box } from '@mui/material';
import { useClickOutside } from '@hooks';
import { Text } from 'components/common/ui';
import styles from './colorPicker.style';

const ColorPicker = ({ value, onChange }) => {
  const popover = useRef();
  const [isOpen, toggle] = useState(false);

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);
  return (
    <Box sx={styles.container} onClick={() => toggle(true)}>
      <Box sx={styles.color} style={{ backgroundColor: value }} />

      <Text>{value}</Text>

      {isOpen && (
        <Box className="popover" ref={popover}>
          <HexColorPicker color={value} onChange={onChange} />
          <HexColorInput color={value} onChange={onChange} />
        </Box>
      )}
    </Box>
  );
};

const memoizedColorPicker = React.memo(ColorPicker);
export { memoizedColorPicker as ColorPicker };

export default memoizedColorPicker;
